<div class="layout-invoice-page">
    <button pButton pRipple type="button" label="Print" icon="pi pi-print" (click)="print()" class="p-mb-3"></button>

    <div class="p-grid layout-invoice-content">
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between">
                    <h5>INVOICE</h5>
                    <div class="p-d-flex p-flex-column p-ai-end">
                        <img src="assets/layout/images/extensions/prime-logo.svg" alt="invoice-logo"/>
                        <p class="p-mt-1">9137 3rd Lane California City, CA 93504.</p>
                    </div>
                </div>

                <div class="p-p-3">
                    <p-table [columns]="billCols" [value]="billData" styleClass="p-invoice-datatable-responsive p-pb-3">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    <span class="p-column-title">{{col.header}}</span>
                                    {{rowData[col.field]}}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <p-table [columns]="productCols" [value]="productData" styleClass="p-invoice-datatable-responsive p-datatable-sm p-py-6">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    <span class="p-column-title">{{col.header}}</span>
                                    {{rowData[col.field]}}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <p-panel header="BANK">
                                <div class="p-d-flex p-ai-center p-jc-between p-py-2">
                                    <span>Bank</span>
                                    <span class="p-text-bold">BestBank</span>
                                </div>
                                <div class="p-d-flex p-ai-center p-jc-between p-pt-2 p-py-2">
                                    <span>ACCOUNT BENEFICIARY</span>
                                    <span class="p-text-bold">Edward Williams</span>
                                </div>
                                <div class="p-d-flex p-ai-center p-jc-between p-pt-2 p-py-2">
                                    <span>SWIFT</span>
                                    <span class="p-text-bold">PJNWBXND</span>
                                </div>
                                <div class="p-d-flex p-ai-center p-jc-between p-pt-2 p-py-2">
                                    <span>IBAN</span>
                                    <span class="p-text-bold">GB04420235692263866724650931</span>
                                </div>
                            </p-panel>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <p-panel header="TOTAL">
                                <div class="p-grid p-text-right">
                                    <div class="p-col-10">
                                        SUBTOTAL
                                    </div>
                                    <div class="p-col-2">
                                        <span class="pink-color">$1304.00</span>
                                    </div>

                                    <div class="p-col-10">
                                        <span>VAT</span>
                                    </div>
                                    <div class="p-col-2">
                                        <span class="pink-color">$234.72</span>
                                    </div>

                                    <div class="p-col-10">
                                        <span>TOTAL</span>
                                    </div>
                                    <div class="p-col-2">
                                        <span class="pink-color">$1538.72</span>
                                    </div>
                                </div>
                            </p-panel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
